import { Control, Controller } from 'react-hook-form';
import { RulesEngineFormValues } from '../rules-engine-form-page';
import { z } from 'zod';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
interface RulesEngineBasicInformationStepProps {
  control: Control<RulesEngineFormValues>;
}

export const RulesEngineBasicInformationStepSchema = z.object({
  basicInfo: z.object({
    ruleName: z.string().min(1, 'Required field'),
    description: z.string(),
  }),
});

export default function RulesEngineBasicInformationStep({
  control,
}: RulesEngineBasicInformationStepProps) {
  return (
    <Grid container columnSpacing={2} rowSpacing={1.5} size={{ xs: 12 }}>
      <Grid size={{ xs: 12, lg: 5 }}>
        <Controller
          name="basicInfo.ruleName"
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              autoFocus
              required
              inputProps={{
                id: 'ruleName',
              }}
              InputLabelProps={{
                htmlFor: 'ruleName',
              }}
              label="Name"
              error={!!fieldState.error}
              helperText={fieldState.error?.message ?? ' '}
              {...field}
              sx={{ width: '100%' }}
              placeholder="Enter rule name"
              autoComplete="off"
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 12, lg: 7 }}>
        <Controller
          name="basicInfo.description"
          control={control}
          render={({ field }) => (
            <TextField
              inputProps={{
                id: 'description',
              }}
              InputLabelProps={{
                htmlFor: 'description',
              }}
              label="Description"
              {...field}
              sx={{ width: '100%' }}
              placeholder="Describe what this rule does"
              autoComplete="off"
            />
          )}
        />
      </Grid>
    </Grid>
  );
}
